import axios from "axios"
import { codigoFacturaRectificativaAdapter } from "./codigoFacturaRectificativa.adapter"
import { EnumReadinDtoProps } from "./DTOs/EnumReadinDto"
import { EnumReadingDtoProps } from "./DTOs/EnumReadingDto"
import { formasCobroPagoAdapter } from "./Enum.adapter"

export async function getCodigoFacturaRectificativa(): Promise<
  EnumReadinDtoProps[]
> {
  const { data } = await axios.get("/Enum/codigo-rectificativa")
  return data.map((item: EnumReadinDtoProps) =>
    codigoFacturaRectificativaAdapter(item)
  )
}

export async function getFormasCobro(): Promise<EnumReadingDtoProps[]> {
  const { data } = await axios.get("/Enum/formas-cobro")
  return data.map((item: EnumReadingDtoProps) => formasCobroPagoAdapter(item))
}

export async function getFormasPago(): Promise<EnumReadingDtoProps[]> {
  const { data } = await axios.get("/Enum/formas-pago")
  return data.map((item: EnumReadingDtoProps) => formasCobroPagoAdapter(item))
}
